import React from 'react';
import { motion } from 'motion/react';
import { Badge } from '../../ui/Badge';
import { Card, CardContent } from '../../ui/Card';
import { Star } from 'lucide-react';

const ClientsReview = ({testimonials}) => {
  return (
    <section className="py-5" style={{ background: 'linear-gradient(135deg, #3b82f6, #8b5cf6)' }}>
        <div className="container px-3 text-white">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="text-center mb-5"
          >
            <Badge className="mb-2 bg-light text-primary border-0">Client Success Stories</Badge>
            <h2 className="display-4 fw-bold mb-3">What Our Clients Say</h2>
            <p className="lead text-white mb-4">
              Don't just take our word for it. Here's what our satisfied clients have to say about working with us.
            </p>
          </motion.div>

          <div className="row row-cols-1 row-cols-md-3 g-4">
            {testimonials.map((testimonial, index) => (
              <motion.div
                key={testimonial.name}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: index * 0.1 }}
                whileHover={{ y: -5 }}
              >
                <Card className="bg-dark text-white rounded-3 border-0 shadow-sm overflow-hidden">
                  <CardContent className="p-4">
                    <div className="d-flex mb-3">
                      {Array.from({ length: testimonial.rating }).map((_, i) => (
                        <Star key={i} className="text-warning" size={20} />
                      ))}
                    </div>
                    <p className="fst-italic">"{testimonial.content}"</p>
                    <div className="d-flex align-items-center mt-3">
                      {/* <ImageWithFallback
                        src={testimonial.image}
                        alt={testimonial.name}
                        className="rounded-circle me-3"
                        style={{ width: '48px', height: '48px', objectFit: 'cover' }}
                      /> */}
                      <div>
                        <h5 className="mb-0">{testimonial.name}</h5>
                        <p className="small mb-0">{testimonial.position}</p>
                      </div>
                    </div>
                  </CardContent>
                </Card>
              </motion.div>
            ))}
          </div>
        </div>
      </section>
  )
}

export default ClientsReview